// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"grid\" width=\"50\" height=\"50\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"2\" fill=\"rgba%28255,255,255,0.1%29\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grid%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #025c4f 0%, #247761 50%, #46b4a0 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: drift 30s linear infinite;
}

@keyframes drift {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(50px, 50px);
  }
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 480px;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  background: linear-gradient(135deg, #025c4f 0%, #247761 100%);
  color: white;
  padding: 40px 32px 32px;
  text-align: center;
}

.login-header h1 {
  margin: 0 0 12px 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.login-subtitle {
  margin: 0;
  font-size: 15px;
  opacity: 0.9;
  font-weight: 400;
}

.login-content {
  padding: 40px 32px;
  text-align: center;
}

.login-icon {
  margin: 0 auto 24px;
  display: flex;
  justify-content: center;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.login-content h2 {
  margin: 0 0 12px 0;
  font-size: 26px;
  font-weight: 700;
  color: #025c4f;
}

.login-description {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 32px 0;
}

.login-button {
  width: 100%;
  padding: 16px 32px;
  background: linear-gradient(135deg, #025c4f 0%, #247761 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(2, 92, 79, 0.3);
  position: relative;
  overflow: hidden;
}

.login-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(2, 92, 79, 0.4);
}

.login-button:hover::before {
  left: 100%;
}

.login-button:active {
  transform: translateY(0);
}

.login-features {
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid #e6e6e6;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}

.feature-icon {
  font-size: 28px;
}

.login-footer {
  background: #f6f6ee;
  padding: 20px 32px;
  text-align: center;
  border-top: 1px solid #e6e6e6;
}

.login-footer p {
  margin: 0;
  font-size: 13px;
  color: #999;
}

@media (max-width: 600px) {
  .login-card {
    margin: 0;
    border-radius: 12px;
  }
  
  .login-header h1 {
    font-size: 24px;
  }
  
  .login-content {
    padding: 32px 24px;
  }
  
  .login-features {
    flex-direction: column;
    gap: 16px;
  }
  
  .feature-item {
    flex-direction: row;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA4T;EAC5T,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #025c4f 0%, #247761 50%, #46b4a0 100%);\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"grid\" width=\"50\" height=\"50\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"2\" fill=\"rgba(255,255,255,0.1)\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grid)\"/></svg>');\n  animation: drift 30s linear infinite;\n}\n\n@keyframes drift {\n  from {\n    transform: translate(0, 0);\n  }\n  to {\n    transform: translate(50px, 50px);\n  }\n}\n\n.login-card {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 480px;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  background: linear-gradient(135deg, #025c4f 0%, #247761 100%);\n  color: white;\n  padding: 40px 32px 32px;\n  text-align: center;\n}\n\n.login-header h1 {\n  margin: 0 0 12px 0;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.login-subtitle {\n  margin: 0;\n  font-size: 15px;\n  opacity: 0.9;\n  font-weight: 400;\n}\n\n.login-content {\n  padding: 40px 32px;\n  text-align: center;\n}\n\n.login-icon {\n  margin: 0 auto 24px;\n  display: flex;\n  justify-content: center;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n.login-content h2 {\n  margin: 0 0 12px 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #025c4f;\n}\n\n.login-description {\n  color: #666;\n  font-size: 15px;\n  line-height: 1.6;\n  margin: 0 0 32px 0;\n}\n\n.login-button {\n  width: 100%;\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #025c4f 0%, #247761 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(2, 92, 79, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(2, 92, 79, 0.4);\n}\n\n.login-button:hover::before {\n  left: 100%;\n}\n\n.login-button:active {\n  transform: translateY(0);\n}\n\n.login-features {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 32px;\n  padding-top: 32px;\n  border-top: 1px solid #e6e6e6;\n}\n\n.feature-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #666;\n}\n\n.feature-icon {\n  font-size: 28px;\n}\n\n.login-footer {\n  background: #f6f6ee;\n  padding: 20px 32px;\n  text-align: center;\n  border-top: 1px solid #e6e6e6;\n}\n\n.login-footer p {\n  margin: 0;\n  font-size: 13px;\n  color: #999;\n}\n\n@media (max-width: 600px) {\n  .login-card {\n    margin: 0;\n    border-radius: 12px;\n  }\n  \n  .login-header h1 {\n    font-size: 24px;\n  }\n  \n  .login-content {\n    padding: 32px 24px;\n  }\n  \n  .login-features {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .feature-item {\n    flex-direction: row;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
